import { useState } from "react";
import { Modal } from "risa-oasis-ui_v2";
import { ModalId } from "../../../../shared/enums/modalId";
import WarningIcon from "../../../../shared/svg/warningIcon";

export type AgenticAuthOnFileToggleField = "live" | "agent_mode";

interface AgenticAuthOnFileToggleDialogProps {
  onClose: () => void;
  onConfirm: (remarks: string) => void;
  metaData?: {
    field: AgenticAuthOnFileToggleField;
    switchState: boolean;
    payerDisplayName?: string;
  };
}

function getCopy(field: AgenticAuthOnFileToggleField, isEnabling: boolean) {
  if (field === "live") {
    return isEnabling
      ? {
          title: "Enable Live",
          warning: "This will turn Live on for this payer.",
          prompt: "Please provide the reason for enabling Live.",
        }
      : {
          title: "Disable Live",
          warning: "This will turn Live off for this payer.",
          prompt: "Please provide the reason for disabling Live.",
        };
  }
  return isEnabling
    ? {
        title: "Enable Agent Mode",
        warning: "This will enable Agent Mode for this payer.",
        prompt: "Please provide the reason for enabling Agent Mode.",
      }
    : {
        title: "Remove Agent Mode",
        warning: "This will pause Agent Mode for this payer (human review).",
        prompt:
          "Please provide the reason for shifting this payer to human review.",
      };
}

export default function AgenticAuthOnFileToggleDialog({
  onClose,
  onConfirm,
  metaData,
}: AgenticAuthOnFileToggleDialogProps) {
  const [comments, setComments] = useState("");
  const field = metaData?.field ?? "live";
  const isEnabling = metaData?.switchState === true;
  const { title, warning, prompt } = getCopy(field, isEnabling);

  return (
    <Modal
      dialogId={ModalId.AGENTIC_AUTH_ON_FILE_TOGGLE_DIALOG}
      title={title}
      onCancel={onClose}
      onClose={onClose}
      onSave={() => onConfirm(comments.trim())}
      cancelText="Cancel"
      saveButtonText="Confirm"
      disableSave={!comments.trim()}
    >
      <div className="toggle-switch-confirmation-content flex flex-col gap-4">
        {metaData?.payerDisplayName ? (
          <div className="text-small font-normal text-primaryGray-2">
            Payer:{" "}
            <span className="font-semibold text-primaryGray-1">
              {metaData.payerDisplayName}
            </span>
          </div>
        ) : null}
        <div className="warning-icon-automation flex flex-row items-center gap-2 bg-red-50 p-2">
          <WarningIcon outerFillColor="black" height="16" width="16" />
          <div className="text-small font-normal">{warning}</div>
        </div>
        <div className="w-full">
          <div className="mb-2 text-small font-normal text-primaryGray-2">
            {prompt}
          </div>
          <textarea
            className="h-20 w-full rounded-md border border-gray-300 p-2 text-tiny font-normal"
            value={comments}
            onChange={(e) => setComments(e.target.value)}
          />
        </div>
      </div>
    </Modal>
  );
}
